import React, { useEffect } from "react";
import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";
import { datadogRum } from "@datadog/browser-rum";

interface AssetListItem {
  asset_id: number;
  asset_name: string;
  group_status_code?: string;
}

interface AssetDropDownProps {
  onAssetsFetched: (assets: AssetListItem[]) => void;
}

const AssetDropDown: React.FC<AssetDropDownProps> = ({ onAssetsFetched }) => {
  useEffect(() => {
    const fetchAssets = async () => {
      const headers = await getHeaders();
      const startTime = performance.now();

      try {
        const response = await apiClient.get(`/assets/?page=1&page_size=500`, {
          headers,
        });
        const fetchedAssets = response.data.response.data.map((asset: any) => ({
          asset_id: asset.asset_id,
          asset_name: asset.asset_name,
          group_status_code: asset.group_status_code,
        }));

        onAssetsFetched(fetchedAssets);

        datadogRum.addAction("Fetched Assets Successfully", {
          assetCount: fetchedAssets.length,
        });
      } catch (err) {
        console.error("Failed to fetch assets", err);
        onAssetsFetched([]);

        datadogRum.addError("Failed to fetch assets", { error: err });
      } finally {
        const endTime = performance.now();
        const duration = endTime - startTime;

        datadogRum.addAction("Asset API Response Time", { duration: duration });
      }
    };

    fetchAssets();
  }, []);

  return null;
};

export default AssetDropDown;
